import {
  ColumnDef,
  Row,
  RowData,
  SortingState,
  TableOptions,
  VisibilityState,
} from "@tanstack/react-table"
import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query"
import { Dispatch, SetStateAction } from "react"
import { Pagination } from "@/utils/Pagination"
import {
  PaperProps,
  TableTdProps,
  TableThProps,
  TableTrProps,
} from "@mantine/core"

export type TheasoftColumnDef<T extends RowData> = ColumnDef<T> & {
  headerProps?: TableThProps
  cellProps?: TableTdProps
}

export type RowProps = Omit<
  TableTrProps,
  "ref" | "key" | "data-index" | "display" | "pos"
>

export type ColumnVisibility = Record<string, boolean>

export type SortingStateAndUpdater = [
  SortingState,
  Dispatch<SetStateAction<SortingState>>,
]

export interface BasicTableProps<TData> {
  data: TData[]
  columnDefinitions: TheasoftColumnDef<TData>[]
  getRowProps?: (row: Row<TData>) => RowProps | undefined
  sortingState?: SortingStateAndUpdater
  tableContainerProps?: PaperProps
  defaultColumnVisibility?: VisibilityState
  isLoading?: boolean
  id: string
  tableOptions?: Partial<TableOptions<TData>>
  withSettingsMenu?: boolean
}

export interface BaseTableProps<TData> extends BasicTableProps<TData> {
  onTableScroll?: (containerRefElement: HTMLDivElement) => void
}

export type InfiniteScrollingTableProps<TData> = Omit<
  BasicTableProps<TData>,
  "data" | "isLoading"
> & {
  infiniteQueryResult: UseInfiniteQueryResult<InfiniteData<Pagination<TData>>>
}
